var _rect, _line, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopMiddleCabinet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 214,
    viewBox: "0 0 217 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 214,
    fill: "#E2E2E2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: -8.74228e-8,
    x2: 111,
    y2: 214,
    stroke: "#7F6969",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 172.5,
    r: 7.5,
    fill: "#7F6969"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 172.5,
    r: 7.5,
    fill: "#7F6969"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopMiddleCabinet);
export default __webpack_public_path__ + "static/media/top_middle_cabinet.9ef8ff920cb5c6fd9250bb32a84a997e.svg";
export { ForwardRef as ReactComponent };